import { redirect, type LoaderFunctionArgs } from 'react-router-dom';
import { appRoutes, contracts } from '@immo/api-contract';
import { loadWorkspaceShell } from '@/lib/auth/workspace-context';
import { nonRouteRules } from '@/lib/permissions/non-route-rules';
import { mayCall } from '@/lib/permissions/route-gate';
import { dashboardLoader, type DashboardLoaderData } from './dashboard/dashboard.loader';

export async function workspaceHomeLoader(args: LoaderFunctionArgs): Promise<DashboardLoaderData> {
  const shell = await loadWorkspaceShell(args.params.workspaceId);

  if (!mayCall(shell.permissions, contracts.dashboard.funnel) && mayCall(shell.permissions, nonRouteRules.hlreArea)) {
    throw redirect(appRoutes.hlre(shell.workspaceSlug));
  }

  return dashboardLoader(args);
}
